import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NationalRegisterService {

  constructor(protected client: HttpClient) { }

  lookup(kt: string) {
    return this.client.get<INationalRegisterEntry>(`/api/nationalregister?kt=${kt}`);
  }
}

export interface INationalRegisterEntry {
  name: string;
}
